import type {
  SankeyLink as D3SankeyLink,
  SankeyNode as D3SankeyNode,
} from 'd3-sankey';

import type {
  SankeyLink,
  SankeyLinkValidated,
  SankeyNode,
  SankeyNodeValidated,
} from './types';

const isFiniteNumber = (value: number | undefined): value is number =>
  // biome-ignore lint/suspicious/noGlobalIsNan: matches sibling sankey validator
  value !== undefined && !isNaN(value);

const validateNode = (
  node: D3SankeyNode<SankeyNode, SankeyLink>
): node is SankeyNodeValidated =>
  isFiniteNumber(node.x0) &&
  isFiniteNumber(node.x1) &&
  isFiniteNumber(node.y0) &&
  isFiniteNumber(node.y1) &&
  isFiniteNumber(node.depth) &&
  isFiniteNumber(node.value);

export const validateNodes = (
  nodes: D3SankeyNode<SankeyNode, SankeyLink>[]
): SankeyNodeValidated[] => nodes.filter(validateNode);

export const validateLinks = (
  links: D3SankeyLink<SankeyNode, SankeyLink>[]
): SankeyLinkValidated[] =>
  links.filter((link): link is SankeyLinkValidated => {
    return (
      isFiniteNumber(link.width) &&
      isFiniteNumber(link.y0) &&
      isFiniteNumber(link.y1) &&
      typeof link.source === 'object' &&
      typeof link.target === 'object' &&
      validateNode(link.source) &&
      validateNode(link.target)
    );
  });
